export default __webpack_public_path__ + "static/media/014-ketchup & mustard.1e0f572d.svg";